import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.scss']
})

export class HeaderTitleComponent {

}

@NgModule({
  declarations: [HeaderTitleComponent],
  imports: [
    CommonModule
  ], 
  exports: [HeaderTitleComponent]
})
export class HeadersTitleModule { }